import { useEffect, useState } from 'react';
import { useReportService } from '../../../services/reportService';

// The car photo from the landing preview page, shown again in the Complete plan's column:
// { photo, name } for a car in the base with photos, otherwise null.
export const useVehiclePhoto = (vinCode, { enabled }) => {
    const [vehicle, setVehicle] = useState(null);
    const { getVehiclePreview } = useReportService();

    useEffect(() => {
        if (!vinCode || !enabled) {
            setVehicle(null);
            return;
        }

        let isCurrent = true;

        getVehiclePreview(vinCode).then(preview => {
            const photo = preview?.gallery?.[0];

            if (isCurrent) {
                setVehicle(photo ? { photo, name: `${preview.header.manufacturer} ${preview.header.model}` } : null);
            }
        });

        return () => {
            isCurrent = false;
        };
    }, [vinCode, enabled]);

    return vehicle;
};
